export default "/images/8ab802b235386fa6a41a58b7d8b11dc2.avif";